/**
 * Formata um número para o padrão de exibição (ex: BR, US, ES)
 * com base na localidade (i18n).
 *
 * @param {number} value - O número a ser formatado.
 * @param {string} locale - A string de localidade (ex: 'pt-BR', 'en-US', 'es').
 * @returns {string} O número formatado como string.
 */
export const formatNumber = (value, locale, max = 2) => {
    // Cria um novo Intl.NumberFormat com opções para casas decimais.
    if (value) {
        const formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: max,
            maximumFractionDigits: max,
        });

        return formatter.format(value);
    }
};

export function formatBytesToMB(bytes) {
    if (!bytes) return "0 MB";

    const mb = bytes / 1024 / 1024;

    if (mb > 1024) {
        return (mb / 1024).toFixed(2) + " GB";
    }

    return mb.toFixed(2) + " MB";
}
